module.exports = __webpack_public_path__ + "img/04_stylii_M447.f5e9bf4c.png";